var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_view__reporError"},[_c('h1',{staticClass:"user_view__reporError--text"},[_vm._v("LO SENTIMOS TENEMOS ERROR EN LA CONEXION")]),_vm._v(" "),_c('button',{staticClass:"user_view__reporError__button",on:{"click":_vm.handleReload}},[_vm._v("\n        Volver a cargar\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a485ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ReportsError.vue
// module id = null
// module chunks = 